import Length from "../../../../source/js/shared/models/Geometry/Length";
import Shape from "./Shape";

export default class Trapezoid extends Shape {

	getPath( offset: Length ): object[] {
		const originalPaths = super.getPath( offset );

		return originalPaths.map( entry => {
			if ( entry[ 'name' ] === 'width_top_Bottom' ) {
				entry[ 'origin' ] = entry[ 'end' ];
			}

			return entry;
		} );
	}
}
